import { render, staticRenderFns } from "./ViewTicket.vue?vue&type=template&id=0c268dde&scoped=true&"
import script from "./ViewTicket.vue?vue&type=script&lang=js&"
export * from "./ViewTicket.vue?vue&type=script&lang=js&"
import style0 from "./ViewTicket.vue?vue&type=style&index=0&id=0c268dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c268dde",
  null
  
)

export default component.exports